import { Resources } from 'constants/resources';

import { useGetList, useGetOne } from 'react-admin';
import { MethodLogo } from 'types/embedded/methodLogo';

const DEFAULT_LOGO_NAME = 'No_logo';

export const useMethodDefaultLogo = (
  newLogoId?: string | null,
  recordLogoIri?: string | null,
): MethodLogo | undefined => {
  const hasLogo = !!newLogoId || !!recordLogoIri;

  const { data: logo } = useGetOne<MethodLogo>(
    Resources.MethodLogos,
    { id: newLogoId || recordLogoIri || '' },
    { enabled: hasLogo },
  );

  const { data: noLogos } = useGetList<MethodLogo>(
    Resources.MethodLogos,
    {
      filter: { name: DEFAULT_LOGO_NAME },
      pagination: { page: 1, perPage: 50 },
    },
    { enabled: !hasLogo },
  );

  return logo || noLogos?.find((item) => item.name === DEFAULT_LOGO_NAME);
};
